import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";
import { options } from "./constants";
import { TLogger } from "../logger/types";

/*
 * For best results, import and instantiate the BrowserAgent class as close
 * to the top of the head element of your app's HTML output as possible.
 * The agent loader code executes immediately on instantiation.
 */
export const newRelicAgent = new BrowserAgent(options);

export const newRelicLogger: TLogger = {
  error: (error, meta) => {
    // Ensure error has a stack trace
    if (!error.stack) {
      const stackError = new Error(error.message);
      stackError.name = error.name;
      error = Object.assign(stackError, error);
    }
    
    // Add timestamp to metadata
    const metaWithTimestamp = {
      ...meta,
      timestamp: new Date().toISOString(),
    };
    
    newRelicAgent.noticeError(error, metaWithTimestamp);
  },
  info: (message, meta) => {
    newRelicAgent.log(message, {
      customAttributes: {
        ...(meta ?? {}),
        timestamp: new Date().toISOString(),
      },
      level: "INFO",
    });
  },
  warn: (message, meta) => {
    newRelicAgent.log(message, {
      customAttributes: {
        ...(meta ?? {}),
        timestamp: new Date().toISOString(),
      },
      level: "WARN",
    });
  },
  debug: (message, meta) => {
    newRelicAgent.log(message, {
      customAttributes: {
        ...(meta ?? {}),
        timestamp: new Date().toISOString(),
      },
      level: "DEBUG",
    });
  },
  trace: (message, meta) => {
    newRelicAgent.log(message, {
      customAttributes: {
        ...(meta ?? {}),
        timestamp: new Date().toISOString(),
      },
      level: "TRACE",
    });
  },
  setCustomAttribute: (key, value) => {
    newRelicAgent.setCustomAttribute(key, value);
  },
};
